import React from "react";
import InfoBanner from '../InfoBanner'

/**
 * Componente para mostrar la new Growth Marketing (Contenido estático).
 *
 * @component
 *
 */

export const GrowthMarketing = (props) => {
  const [width, setWidth] = React.useState(window.innerWidth);
  const breakpoint = 620;

  React.useEffect(() => {
    /* Inside of a "useEffect" hook add an event listener that updates
        the "width" state variable when the window size changes */
    window.addEventListener("resize", () => setWidth(window.innerWidth));

    /* passing an empty array as the dependencies of the effect will cause this
        effect to only run when the component mounts, and not each time it updates.
        We only want the listener to be added once */
  }, []);

  const url = window.location.href;

  return (
    <section id="news-detail" className="text-center">
      <div className="col-md-8 col-md-offset-2 section-title">
        <h2>
          <span className="title">News</span>
        </h2>
      </div>
      <InfoBanner
        section={'Growth Marketing'}
        tittle={'Growth Marketing: crecimiento inteligente en la era digital'}
        readingTime={'Tiempo de lectura 4 minutos'}
        keywords={['Growth Marketing', 'Análisis de Datos']}
        urlDesktop={'/img/news/GrowthMarketing/GrowthMarketing_img1.webp'}
        urlMobile={'/img/news/GrowthMarketing/GrowthMarketing_img1_mob.webp'}
      />
      <div className="container-fluid padding-fluid">
        <div className="row">
          <div className="col-md-12 visible-md visible-lg">
            <div className="col-md-1">&nbsp;</div>
          </div>
          <div className="col-md-12 visible-md visible-lg">
            <div className="col-md-1">&nbsp;</div>
          </div>
          <div className="col-md-12 visible-md visible-lg">
            <div className="col-md-1">&nbsp;</div>
          </div>
          <div className="col-md-12">
            <div className="col-md-1">&nbsp;</div>
          </div>
          <article className="col-md-12">
            <div className="col-md-8 col-md-offset-2 text-center">
              <p>
              El Growth Marketing emerge como una fuerza impulsora en la era digital, revolucionando las prácticas tradicionales de inversión y destacando su relevancia en el ámbito del marketing digital. En el corazón de esta transformación se encuentra el concepto de embudo o funnel de conversión, una representación gráfica del viaje del cliente a través de las distintas etapas, desde la conciencia hasta la conversión final.
                <br></br>
                <br></br>
              </p>
            </div>
          </article>
        </div>
      </div>
      <article
        className={width < breakpoint ? "" : "container-fluid padding-fluid"}
      >
        <div className={width < breakpoint ? "" : "row"}>
          <div className={width < breakpoint ? "" : "col-md-12"}>
            <div className={width < breakpoint ? "" : "col-md-8 col-md-offset-2 text-center"}>
              <img
                style={{ width: "100%" }}
                alt="Desbloqueando Potencial"
                className="img-responsive"
                src="/img/news/GrowthMarketing/GrowthMarketing_img2.webp"
              ></img>
              <h2 className="img3Text">El Growth Marketing se centra en el embudo de conversión para guiar el viaje del cliente desde la conciencia hasta la conversión final.</h2>
            </div>
          </div>
        </div>
      </article>
      <article className="container-fluid padding-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="col-md-8 col-md-offset-2 text-center">
              <p>
                En contraste con las estrategias de outbound marketing, que se centran en la exposición masiva, el Growth Marketing adopta un enfoque más selectivo y centrado en el cliente. Este método se alinea perfectamente con la filosofía del inbound marketing, que busca atraer a los clientes mediante contenido relevante y valioso. La combinación de ambas estrategias crea un entorno propicio para el crecimiento empresarial sostenido.
                <br></br>
                <br></br>
                <b>
                El marketing de contenidos se erige como un pilar esencial en este contexto, nutriendo al funnel de conversión con información valiosa en cada etapa
                </b>{" "}
                Las marcas deben adaptar sus mensajes y tácticas según el lugar específico en el embudo, desde la creación de conciencia hasta la conversión final. Es en este punto donde las estrategias de crecimiento despliegan todo su potencial.
                <br></br>
                <br></br>
              </p>
            </div>
          </div>
        </div>
      </article>
      <div
        className={width < breakpoint ? "" : "container-fluid padding-fluid"}
      >
        <div className={width < breakpoint ? "" : "row"}>
          <div className={width < breakpoint ? "" : "col-md-12"}>
            <div className={width < breakpoint ? "" : "col-md-8 col-md-offset-2 text-center"}>
              <img
                style={{ width: "100%" }}
                alt="Desbloqueando Potencial"
                className="img-responsive"
                src="/img/news/GrowthMarketing/GrowthMarketing_img3.webp"
              ></img>
              <h2 className="img3Text">Esta estrategia refleja una mentalidad empresarial proactiva y adaptable que puede prosperar en un entorno en constante cambio.</h2>
            </div>
          </div>
        </div>
      </div>
      <article className="container-fluid padding-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="col-md-8 col-md-offset-2 text-center">
              <p>
                <b>
                Parte de los elementos clave en el arsenal del Growth Marketing son los datos y la utilización de métricas clave.
                </b>{" "}
                Estas métricas proporcionan una visión clara del rendimiento de una campaña, permitiendo ajustes en tiempo real. Mientras que, el análisis de datos preciso se convierte en la brújula que guía las decisiones estratégicas, asegurando que cada acción contribuya al crecimiento digital.
                <br></br>
                <br></br>
                Un aspecto esencial del Growth Marketing es la comprensión profunda del funnel de conversión de cada marca. Cada etapa requiere enfoques distintos, desde el uso efectivo de las redes sociales en la conciencia hasta la optimización de motores de búsqueda y publicidad paga en la conversión. Es un proceso dinámico y adaptativo que garantiza un crecimiento empresarial sostenible.
                <br></br>
                <br></br>
                Un ejemplo ilustrativo de los resultados tangibles del Growth Marketing se observa en la {" "}
                <b>
                estrategia de colocación digital de productos de una empresa financiera que la ejecutamos desde RAM.
                </b>{" "}
                 La marca enfocaba su estrategia en bases de datos confiables que aseguraban una mayor tasa de conversión; sin embargo, esto comprendía únicamente el 10% de leads posibles sobre el universo. Desde RAM identificamos a través de la data que, un enfoque más amplio y diversificado, podría dar lugar a un crecimiento exponencial a nuestro cliente. La estrategia se ajustó para nutrir leads a través de múltiples canales, asegurando que las comunicaciones fueran coherentes en cada etapa del proceso. Esta adaptación resultó en un crecimiento explosivo en las tasas de conversión y una colocación de productos significativamente mejorada.
                <br></br>
                <br></br>
                <b>
                Adoptar una perspectiva de digital growth implica entender la orquestación precisa entre las estrategias de marketing digital, inbound marketing, outbound marketing, y la aplicación hábil de un análisis de datos preciso.
                </b>{" "}
                Empresas que abrazan esta visión no solo crecen; prosperan en el dinámico paisaje empresarial actual.
              </p>
            </div>
            <div className="col-md-1 text-left"></div>
            <div
              className="col-md-3 text-left"
              style={{ display: width < breakpoint ? "block" : "none" }}
            >
              <p className="titleShare">COMPARTE</p>
              <div style={{ paddingBottom: "7px" }}>
                <a
                  className="share"
                  href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Facebook
                </a>
              </div>
              <div style={{ paddingBottom: "7px" }}>
                <a
                  className="share"
                  href={`https://twitter.com/intent/tweet?url=${url}&text=Growth Marketing`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Twitter
                </a>
              </div>
              <div style={{ paddingBottom: "7px" }}>
                <a
                  className="share"
                  href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LinkedIn
                </a>
              </div>
              <div style={{ paddingBottom: "7px" }}>
                <a
                  className="share"
                  href={`mailto:?subject=Quiero compartir contigo esta noticia&body=Mira esta noticia ${url}`}
                >
                  Email
                </a>
              </div>
            </div>
          </div>
        </div>
      </article>
    </section>
  );
};
